var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOurBranchesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_976_11416",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H20V20H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_976_11416)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 20.0142C10.2111 20.0142 10.4066 19.9033 10.5149 19.7222L12.625 16.1954C15.931 15.0964 18.3165 11.979 18.3165 8.30248C18.3165 3.70943 14.5931 -0.0139637 10 -0.0139637C5.40699 -0.0139637 1.68359 3.70943 1.68359 8.30248C1.68359 11.979 4.06907 15.0964 7.3751 16.1954L9.48515 19.7222C9.5935 19.9033 9.78901 20.0142 10 20.0142ZM10 18.2455L8.28809 15.3841C8.21129 15.2558 8.08933 15.1607 7.94611 15.1176C5.01659 14.236 2.88359 11.5177 2.88359 8.30248C2.88359 4.37217 6.06973 1.18604 10 1.18604C13.9303 1.18604 17.1165 4.37217 17.1165 8.30248C17.1165 11.5177 14.9835 14.236 12.054 15.1176C11.9107 15.1607 11.7888 15.2558 11.712 15.3841L10 18.2455Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.92432 9.6915C4.92432 10.0229 5.19295 10.2915 5.52432 10.2915H14.4754C14.8068 10.2915 15.0754 10.0229 15.0754 9.6915C15.0754 9.36013 14.8068 9.0915 14.4754 9.0915H5.52432C5.19295 9.0915 4.92432 9.36013 4.92432 9.6915Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.36416 10.3013C6.69553 10.3013 6.96416 10.0326 6.96416 9.70127V9.10959C6.96416 7.44104 8.33182 6.07338 10.0004 6.07338C11.6689 6.07338 13.0366 7.44118 13.0366 9.10959V9.70127C13.0366 10.0326 13.3052 10.3013 13.6366 10.3013C13.968 10.3013 14.2366 10.0326 14.2366 9.70127V9.10959C14.2366 6.77847 12.3317 4.87338 10.0004 4.87338C7.66908 4.87338 5.76416 6.7783 5.76416 9.10959V9.70127C5.76416 10.0326 6.03279 10.3013 6.36416 10.3013Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.9999 6.05225C10.3313 6.05225 10.5999 5.78362 10.5999 5.45225V4.85557C10.5999 4.5242 10.3313 4.25557 9.9999 4.25557C9.66853 4.25557 9.3999 4.5242 9.3999 4.85557V5.45225C9.3999 5.78362 9.66853 6.05225 9.9999 6.05225Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOurBranchesIcon);
export default __webpack_public_path__ + "static/media/our-branches-icon.b6437a99b514313fbd8de7adf1e91367.svg";
export { ForwardRef as ReactComponent };